import { EModColorBgText } from '@ucheba/utils/helpers/styles/mod.types'
import { EModButtonColor } from '@ucheba/ui/components/Button/types'

export interface IBlockWithCards {
  type: string
  title?: string | null
  items: IItemCard[]
  button?: {
    color: keyof typeof EModButtonColor | null
  }
}

interface IItemCard<T = never> {
  icon: string | null
  subTitle: string | null
  title: string | null
  text: string | null
  color: keyof typeof EModColorBgText | T
}

export enum EColorCardTitle {
  gold = 'orange',
  lime = 'emerald',
  rose = 'pink',
  blue = 'white',
  rose50 = 'red',
  navy = 'white',
  silver = 'black',
  white = 'black',
  black = 'white',
  yellow = 'orange',
  acid = 'emerald',
  flamingo = 'maroon',
  plum = 'flamingo',
  orange = 'white',
}
//
// export enum EColorText {
//   gold = 'coffee',
//   lime = 'pine',
//   rose = 'maroon',
//   blue = 'white',
// }
